<template>
  <div
    id="form-search-popover"
    class="container-app-search"
  >
    <!-- Header -->
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header"
      style="padding-bottom: 0 !important; padding-top: 15px !important; height: 110px"
    >
      <div class="title-tab-experience-manager">APPLICATION MANAGER</div>
      <div class="d-flex m__t--42">
        <div
          v-for="tab in tabs"
          :key="tab.id"
          :class="{'tab-experience-manager-active' : tabSelected === tab.id}"
          class="tab-experience-manager m__r--35"
          @click="tabSelected = tab.id"
        >
          {{ tab.text }}
        </div>
      </div>
    </div>

    <!-- Content -->
    <div class="studio-page-content">
      <j-application-app-tab v-if="tabSelected === 'apps'"/>
      <j-application-group-tab v-if="tabSelected === 'group'"/>
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { mapState, mapActions } from 'vuex';
// Components
import jApplicationAppTab from '@/views/application-manager/tabs/jApplicationAppTab';
import jApplicationGroupTab from '@/views/application-manager/tabs/jApplicationGroupTab';

export default {
  components: {
    jApplicationAppTab,
    jApplicationGroupTab,
  },

  data() {
    return {
      tabs: [
        { id: 'apps', text: 'APPLICATION' },
        { id: 'group', text: 'GROUP APPS' },
      ],
      tabSelected: 'apps',

      // Apps
    };
  },

  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
  },

  created() {
    this.getDataApps();
    this.getDataGroupApps();
  },

  methods: {
    ...mapActions('jStoreSetting', ['actionGetApplicationsList', 'actionGetGroupApplicationsList']),

    getDataApps() {
      const parameter = {
        page: 1,
        limit: 0,
        column: 'updated_at',
        sort: 'desc',
        query: '',
        query_type: '',
      };
      this.actionGetApplicationsList({ params: parameter });
    },

    getDataGroupApps() {
      const param = {
        params: {
          page: 1,
          limit: 0,
          column: 'updated_at',
          sort: 'desc',
          query: '',
          query_type: '',
        },
      };
      this.actionGetGroupApplicationsList(param);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/jApplicationManager.vue